import React, { Component } from "react";
import { API_FILE_URL } from "../../api/config";
const PUBLIC_URL = process.env.PUBLIC_URL + "/";
class InvestorRelations extends Component {
  // --- Helpers ---
  buildTabId = (item, i) => `ir_tab_${item?.id || i + 2}`;
  isYearlyGroupTitle = (title = "") =>
    /finansal|faaliyet|özel durum|ozel durum|genel kurul/i.test(title);

  fileHref = (file) => {
    if (!file) return "#";
    if (/^https?:\/\//i.test(file)) return file;
    return `${API_FILE_URL}${file}`;
  };

  fmtDate = (iso) => {
    if (!iso) return "";
    try {
      const d = new Date(iso);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    } catch {
      return "";
    }
  };

  // Yıla göre grupla (sayısal yılları DESC sırala, "Diğer" sona)
  groupByYear = (items = []) => {
    const map = {};
    items.forEach((it) => {
      const y = it?.date ? new Date(it.date).getFullYear() : "Diğer";
      if (!map[y]) map[y] = [];
      map[y].push(it);
    });

    const years = Object.keys(map);
    const numeric = years
      .filter((y) => /^\d{4}$/.test(String(y)))
      .map(Number)
      .sort((a, b) => b - a);
    const nonNumeric = years.filter((y) => !/^\d{4}$/.test(String(y)));
    const orderedYears = [...numeric.map(String), ...nonNumeric];

    // Her yılın içini tarihe göre yeni→eski sırala
    orderedYears.forEach((y) => {
      map[y].sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
    });

    return { years: orderedYears, map };
  };

  renderImageGridItems = (items = []) => {
    if (!Array.isArray(items) || items.length === 0)
      return <div>Görsel bulunamadı.</div>;
    return (
      <div className="row g-3">
        {items.map((it) => {
          const src = this.fileHref(it.file);
          return (
            <div className="col-6 col-md-4" key={it.id}>
              <a
                href={src}
                target="_blank"
                rel="noopener noreferrer"
                title={it.title || ""}
              >
                <img
                  src={src}
                  alt={it.title || "image"}
                  style={{
                    width: "100%",
                    height: 160,
                    objectFit: "cover",
                    borderRadius: 8,
                    display: "block",
                  }}
                />
              </a>
              {it.title ? (
                <div
                  style={{ fontSize: 12, marginTop: 6, textAlign: "center" }}
                >
                  {it.title}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  };

  renderFlatListItems = (
    items = [],
    { showDate = false, lang = "tr" } = {}
  ) => {
    if (!Array.isArray(items) || items.length === 0)
      return <div>İçerik bulunamadı.</div>;
    return (
      <ul className="list-unstyled" style={{ margin: 0 }}>
        {items.map((it) => {
          const href = this.fileHref(it.file);
          const date = this.fmtDate(it.date, lang);
          return (
            <li
              key={it.id}
              style={{
                padding: "10px 0",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 0,
              }}
            >
              <img
                src={`${PUBLIC_URL}assets/img/icons/icon-pdf.png`}
                alt="pdf"
                style={{ width: 24, height: "auto" }}
              />
              {href !== "#" ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: 14 }}
                >
                  {it.title || "Dosya"}
                </a>
              ) : (
                <span>{it.title || "Dosya"}</span>
              )}
              {showDate && date ? (
                <span style={{ marginLeft: 10, opacity: 0.7 }}>— {date}</span>
              ) : null}
            </li>
          );
        })}
      </ul>
    );
  };

  renderLinkListItems = (items = []) => {
    if (!Array.isArray(items) || items.length === 0)
      return <div>Bağlantı bulunamadı.</div>;
    return (
      <ul className="list-unstyled" style={{ margin: 0 }}>
        {items.map((it) => {
          const href = it.url || this.fileHref(it.file);
          return (
            <li
              key={it.id}
              style={{
                padding: "10px 0",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 0,
              }}
            >
              <img
                src={`${PUBLIC_URL}assets/img/icons/kap-logo.png`}
                alt="link"
                style={{ width: 24, height: "auto", filter: "invert(1)" }}
              />
              {href && href !== "#" ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: 14 }}
                >
                  {it.date || ""
                    ? `${this.fmtDate(it.date || it.dateISO || "", "tr")} — `
                    : ""}
                  {it.title || href}
                </a>
              ) : (
                <span>{it.title || "Bağlantı"}</span>
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  // İçerik render (section bazlı)
  renderSectionContent = (section, lang = "tr", tabDomId = "ir_tab") => {
    const type = (section?.type || "").toUpperCase();

    // Yıllık akordeon beklenen başlıklar
    if (this.isYearlyGroupTitle(section?.title)) {
      const { years, map } = this.groupByYear(section?.items || []);
      const accId = `${tabDomId}_acc`;

      return (
        <div className="accordion" id={accId}>
          {years.map((year, yi) => {
            const hdrId = `${accId}_h_${year}`;
            const colId = `${accId}_c_${year}`;
            const yearItems = map[year] || [];

            // Yıl başlığının içeriğini TYPE’a göre çiz
            let body = null;
            switch (type) {
              case "PDF":
                body = this.renderFlatListItems(yearItems, {
                  showDate: section?.showDate,
                  lang,
                });
                break;
              case "IMAGE":
                body = this.renderImageGridItems(yearItems);
                break;
              case "LINK":
                body = this.renderLinkListItems(yearItems);
                break;
              case "TEXT":
                // TEXT tipinde genelde yıllık kırılım olmaz; yine de ilk item’in içeriğini gösterelim
                body = (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: (yearItems[0] && yearItems[0].title) || "",
                    }}
                  />
                );
                break;
              default:
                body = this.renderFlatListItems(yearItems, {
                  showDate: section?.showDate,
                  lang,
                });
            }

            return (
              <div className="accordion-item" key={year}>
                <h2 className="accordion-header" id={hdrId}>
                  <button
                    className={`accordion-button ${
                      yi === 0 ? "" : "collapsed"
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${colId}`}
                    aria-expanded={yi === 0 ? "true" : "false"}
                    aria-controls={colId}
                  >
                    {year} {section?.title}
                  </button>
                </h2>
                <div
                  id={colId}
                  className={`accordion-collapse collapse ${
                    yi === 0 ? "show" : ""
                  }`}
                  aria-labelledby={hdrId}
                  data-bs-parent={`#${accId}`}
                >
                  <div className="accordion-body">{body}</div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    // Normal tipler (yıl kırılımı olmayan başlıklar)
    const items = Array.isArray(section?.items) ? section.items : [];
    switch (type) {
      case "PDF":
        return this.renderFlatListItems(items, {
          showDate: section?.showDate,
          lang,
        });
      case "IMAGE":
        return this.renderImageGridItems(items);
      case "LINK":
        return this.renderLinkListItems(items);
      case "TEXT":
        return (
          <div dangerouslySetInnerHTML={{ __html: section?.content || "" }} />
        );
      default:
        return this.renderFlatListItems(items, {
          showDate: section?.showDate,
          lang,
        });
    }
  };

  render() {
    const {
      companyInfos = [],
      investorRelationsData = [],
      lang = "tr",
    } = this.props;

    return (
      <div className="liton__wishlist-area pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__product-tab-area">
                <div className="container">
                  <div className="row">
                    {/* Sol menü */}
                    <div className="col-lg-4">
                      <div className="ltn__tab-menu-list mb-50">
                        <div className="nav">
                          <a
                            className="active show"
                            data-bs-toggle="tab"
                            href="#ltn_tab_company"
                          >
                            Şirket Bilgileri{" "}
                            <i className="fas fa-circle-info" />
                          </a>
                          {investorRelationsData.map((item, i) => {
                            const tabId = this.buildTabId(item, i);
                            return (
                              <a
                                key={item.id || i}
                                data-bs-toggle="tab"
                                href={`#${tabId}`}
                              >
                                {item.title || "-"}{" "}
                                <i
                                  className={item.icon || "fa-solid fa-list"}
                                />
                              </a>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    {/* Sağ içerik */}
                    <div className="col-lg-8">
                      <div className="tab-content">
                        <div
                          className="tab-pane fade active show"
                          id="ltn_tab_company"
                        >
                          <div className="ltn__myaccount-tab-content-inner">
                            {companyInfos.length === 0 ? (
                              <div>Bilgi yok.</div>
                            ) : (
                              companyInfos.map((item, i) => (
                                <p
                                  key={i}
                                  style={{ borderRadius: 10, marginBottom: 10 }}
                                >
                                  <strong>{item.title || "Ünvan"}</strong>
                                  <br />
                                  {item.content || ""}
                                </p>
                              ))
                            )}
                          </div>
                        </div>

                        {investorRelationsData.map((item, i) => {
                          const tabId = this.buildTabId(item, i);
                          return (
                            <div
                              key={item.id || i}
                              className="tab-pane fade"
                              id={tabId}
                            >
                              <div className="ltn__myaccount-tab-content-inner">
                                <h4 style={{ marginBottom: 15 }}>
                                  {item.title}
                                </h4>
                                {this.renderSectionContent(item, lang, tabId)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {/* /Sağ içerik */}
                  </div>
                </div>
              </div>
              {/* PRODUCT TAB AREA END */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InvestorRelations;
